/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAssetsByCommandID(commandID) {
  const response = await $.soap({
    body: {
      GetAssetsByCommandID: {
        $xmlns: 'http://dla.mil/ems/bpm/asset',
        CommandID: commandID
      }
    },
    blueprintArrays: ['GetAssetsByCommandIDResponse.Response.Asset'],
    blueprint: {
      assets: [
        '$..Asset',
        {
          asset: '$.Asset',
          serialNumber: '$.SerialNumber',
          inventoryNumber: '$.InventoryNumber',
          location: '$.Location',
          subLocation: '$.SubLocation',
          facilityText: '$.FacilityText',
          plant: '$.Plant',
          vendor: '$.Vendor',
          manufacturer: '$.Manufacturer',
          orgAquisYear: '$.OrgAquisYear',
          originalValue: '$.OriginalValue',
          make: '$.Make',
          model: '$.Model',
          contractAwardDate: '$.ContractAwardDate',
          contractEndDate: '$.ContractEndDate',
          eqInstallDate: '$.EqInstallDate',
          uninstallDate: '$.UninstallDate',
          piin: '$.PIIN',
          clin: '$.CLIN',
          miprNumber: '$.MIPRNumber',
          material: '$.Material',
          miprCode: '$.MIPRCode',
          leaseTerm: '$.LeaseTerm',
          customerId: '$.CustomerID',
          name: '$.Name',
          email: '$.Email',
          phone: '$.Phone',
          sellingPrice: '$.SellingPrice',
          regionName: '$.RegionName'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.assets;
}
